import { useRef } from "react";

export default function useCopyPlaintext() {
	/*
		This hook is for copying plain text to the clipboard, from within the context of a focus trap.
		The text has to be copied from a <textarea> element to be treated as non-html plain text.
		If a focus trap is present, the <textarea> needs to be within the focus trap for the text to be copyable
		containerRef is a ref to an element within the focus trap.
	*/
	const containerRef = useRef();
	function copyPlaintextToClipboard(text) {
		const textarea = document.createElement("textarea");
		containerRef.current.appendChild(textarea);
		textarea.value = text;
		textarea.focus();
		textarea.select();

		let success = false;
		try {
			success = document.execCommand('copy');
		} finally {
			containerRef.current.removeChild(textarea);
		}

		return success;
	}
	return [containerRef, copyPlaintextToClipboard];
}
